module.exports = __webpack_public_path__ + "img/image_11.a5f3b8c3.jpg";